export default "__VITE_ASSET__DUKV0Vue__"